import { render } from "./PROPOSAL_SPLIT.vue?vue&type=template&id=6f7e4615"
import script from "./PROPOSAL_SPLIT.vue?vue&type=script&lang=js"
export * from "./PROPOSAL_SPLIT.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__